import { useTranslation } from "react-i18next";

interface AllergenWarningProps {
  /** The guest who listed the allergens, when ordering for named guests */
  readonly personName?: string;
  /** Lets a control reference the warning through `aria-describedby` */
  readonly id?: string;
}

/** Tells the guest an item contains allergens they listed, so they can decide what to do with it. */
function AllergenWarning({ personName, id }: AllergenWarningProps) {
  const { t } = useTranslation();
  return (
    <span id={id} className="dietary-warning">
      {personName
        ? t("contains_allergen_for_name", "Contains allergens {{name}} has listed", { name: personName })
        : t("contains_your_allergen", "Contains allergens you have listed")}
    </span>
  );
}

export default AllergenWarning;
